<template>
  <div>
    <PageHeader title="เพิ่มผู้เรียน" icon="fa fa-user-plus" />

    <b-container fluid="xl" class="pt-5">
      <div class="inner bg-container">
        <div class="card card-csq no-shadow">
          <div class="card-header bg-light">
            <ul class="nav nav-tabs card-header-tabs float-left">
              <li class="nav-item">
                <a class="nav-link active" href="#">รายบุคคล</a>
              </li>
              <li class="nav-item">
                <router-link
                  :to="{
                    name: 'group.index',
                    params: { company: company.url },
                  }"
                  class="nav-link text-csq"
                  >กลุ่ม</router-link
                >
              </li>
            </ul>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12 col-lg-12 m-t-25">
                <b-form>
                  <b-alert v-model="showAlert" variant="danger" dismissible>
                    {{ errorMessage }}
                  </b-alert>

                  <!-- ===================== Wannasorn extended learner form ===================== -->
                  <WannasornMemberCreateForm
                    v-if="isWannasorn"
                    :form="form"
                    :errors="errors"
                    :company-id="company.id"
                    :is-set-password="isSetPassword"
                    :is-set-confirm-password="isSetConfirmPassword"
                    @checkUsername="checkUsername"
                    @checkEmail="checkEmail"
                    @passwordConfirmed="setPassword"
                    @passwordCleared="clearPassword"
                  />

                  <!-- ===================== Default learner form (all other companies) ===================== -->
                  <template v-else>
                    <div class="card border-0 no-shadow bg-light mb-3">
                      <div class="card-header pt-3 border-0 bg-transparent">
                        <h5 class="card-title">ข้อมูลผู้เรียน</h5>
                      </div>
                      <div class="card-body pb-0">
                        <div class="form-row">
                          <b-form-group class="col-md-4">
                            <label>ชื่อ (จำเป็น)</label>
                            <b-form-input
                              v-model="form.firstName"
                              :state="
                                !form.firstName ? null : validation.firstName
                              "
                              type="text"
                              placeholder="ชื่อ"
                              :class="{ 'is-invalid': hasError('firstName') }"
                              trim
                              :title="company.id === 513 ? 'กรุณากรอกชื่อเป็นภาษาไทย' : null"
                            ></b-form-input>

                            <b-form-invalid-feedback
                              >กรุณากรอกชื่อ</b-form-invalid-feedback
                            >
                            <b-form-valid-feedback></b-form-valid-feedback>
                          </b-form-group>

                          <b-form-group class="col-md-4">
                            <label>นามสกุล (จำเป็น)</label>
                            <b-form-input
                              v-model="form.lastName"
                              :state="!form.lastName ? null : validation.lastName"
                              type="text"
                              placeholder="นามสกุล"
                              :class="{ 'is-invalid': hasError('lastName') }"
                              trim
                              :title="company.id === 513 ? 'กรุณากรอกนามสกุลเป็นภาษาไทย' : null"
                            ></b-form-input>
                            <b-form-invalid-feedback
                              >กรุณากรอกนามสกุล</b-form-invalid-feedback
                            >
                            <b-form-valid-feedback></b-form-valid-feedback>
                          </b-form-group>
                        </div>
                        <div class="form-row">
                          <b-form-group v-if="!isTutorType() || comId == 525" class="col-md-4">
                            <label>รหัสบัตรประชาชน</label>
                            <b-form-input
                              v-model="form.idCard"
                              :state="!form.idCard ? null : validation.idCard"
                              type="text"
                              placeholder="เลข 13 หลัก"
                              :class="{ 'is-invalid': hasError('idCard') }"
                              trim
                            ></b-form-input>
                            <b-form-invalid-feedback>
                              กรุณากรอกรหัสบัตรประชาชนให้ถูกต้อง
                            </b-form-invalid-feedback>
                          </b-form-group>
                          <b-form-group class="col-md-4">
                            <label>เบอร์โทรศัพท์</label>
                            <b-form-input
                              v-model="form.phoneNumber"
                              :state="
                                !form.phoneNumber ? null : validation.phoneNumber
                              "
                              type="text"
                              maxlength="15"
                              placeholder="0999999999"
                              :class="{ 'is-invalid': hasError('phoneNumber') }"
                              trim
                              @keypress="onNumberKeyPress"
                              @input="form.phoneNumber = form.phoneNumber ? form.phoneNumber.replace(/[^\d]/g, '') : form.phoneNumber"
                            ></b-form-input>
                            <b-form-invalid-feedback>
                              กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง
                            </b-form-invalid-feedback>
                            <b-form-valid-feedback></b-form-valid-feedback>
                          </b-form-group>
                        </div>
                        <b-row>
                          <b-col md="8">
                            <b-form-group
                              class="mb-3"
                              label="เกี่ยวกับผู้เรียน"
                              label-for="textarea-formatter"
                            >
                              <b-form-textarea
                                id="textarea-formatter"
                                v-model="form.about"
                                placeholder="เกี่ยวกับผู้เรียน"
                              ></b-form-textarea>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </div>
                    </div>

                    <div v-if="!(isTutorType()|| isInsuranceType() || isAccountingType())" class="card border-0 bg-light mb-3 no-shadow">
                      <div class="card-header pt-3 border-0 bg-transparent">
                        <h5 class="card-title">ข้อมูลพนักงาน</h5>
                      </div>
                      <div class="card-body pb-0">
                        <div class="form-row">
                          <b-form-group class="col-md-4">
                            <label>รหัสพนักงาน</label>
                            <b-form-input
                              v-model="form.staffId"
                              type="text"
                              placeholder="รหัสพนักงาน"
                              trim
                            ></b-form-input>
                          </b-form-group>
                          <b-form-group class="col-md-4">
                            <label>แผนก</label>
                            <b-form-input
                              v-model="form.department"
                              type="text"
                              placeholder="ชื่อแผนก"
                            ></b-form-input>
                          </b-form-group>
                        </div>
                      </div>
                    </div>

                    <div class="card border-0 bg-light mb-3 no-shadow">
                      <div class="card-header pt-3 border-0 bg-transparent">
                        <h5 class="card-title">ข้อมูลผู้ใช้งาน</h5>
                      </div>
                      <div class="card-body pb-0">
                        <div class="form-row">
                          <b-col md="4">
                            <label>อีเมล</label>
                            <b-form-input
                              v-model="form.email"
                              :state="!form.email ? null : validation.email"
                              :class="{ 'is-invalid': hasError('email') }"
                              type="email"
                              placeholder="example@email.com"
                              trim
                            ></b-form-input>
                            <b-form-invalid-feedback
                              >กรุณากรอกอีเมลให้ถูกต้อง หรือ
                              มีอีเมลนี้ในระบบแล้ว</b-form-invalid-feedback
                            >
                            <b-form-valid-feedback></b-form-valid-feedback>
                          </b-col>
                          <b-form-group class="col-md-4">
                            <label> ชื่อผู้ใช้งาน </label>
                            <b-form-input
                              v-model="form.username"
                              :state="!form.username ? null : validation.username"
                              :class="{ 'is-invalid': hasError('username') }"
                              type="text"
                              placeholder="username"
                              trim
                              @change="checkUsername"
                            ></b-form-input>
                            <b-form-invalid-feedback>
                              ชื่อผู้ใช้งานไม่ถูกต้อง หรือ
                              มีผู้ใช้งานนี้ในระบบอยู่แล้ว</b-form-invalid-feedback
                            >
                            <b-form-valid-feedback></b-form-valid-feedback>
                          </b-form-group>
                        </div>

                        <change-password-form
                          :companyId="company.id"
                          :errors="errors"
                          :isSetPassword="isSetPassword"
                          :isSetConfirmPassword="isSetConfirmPassword"
                          @passwordConfirmed="setPassword"
                          :required="true"
                          @passwordCleared="clearPassword"
                        ></change-password-form>
                      </div>
                    </div>
                  </template>

                  <div class="m-t-35 text-right">
                    <router-link
                      :to="{ name: 'member.index' }"
                      class="btn btn-link text-csq"
                      >ยกเลิก</router-link
                    >
                    <button
                      class="btn btn-dark"
                      type="button"
                      @click="handleSubmit"
                    >
                      บันทึก
                    </button>
                  </div>
                </b-form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.inner -->
    </b-container>

    <!-- ===================== Wannasorn: preview before add ===================== -->
    <WannasornConfirmMemberModal
      v-if="isWannasorn"
      v-model="showConfirmModal"
      :form="form"
      :submitting="submitting"
      @confirm="confirmAddMember"
    />

    <!-- ===================== Wannasorn: success ===================== -->
    <WannasornResultModal
      v-if="isWannasorn"
      v-model="showSuccessModal"
      variant="success"
      title="เพิ่มผู้เรียนสำเร็จ"
      :lines="['ระบบได้สร้างรหัสนักเรียนให้โดยอัตโนมัติเรียบร้อยแล้ว']"
      button-text="เสร็จสิ้น"
      @confirm="finishSuccess"
    >
      <b-row class="justify-content-center mt-4">
        <b-col md="7" class="text-left">
          <b-row class="mb-2">
            <b-col cols="5">ชื่อ - นามสกุล:</b-col>
            <b-col cols="7" class="font-weight-bold">{{ thaiFullName }}</b-col>
          </b-row>
          <b-row>
            <b-col cols="5">รหัสนักเรียน:</b-col>
            <b-col cols="7" class="font-weight-bold">{{ createdStudentId }}</b-col>
          </b-row>
        </b-col>
      </b-row>
    </WannasornResultModal>

    <!-- ===================== Wannasorn: add error ===================== -->
    <WannasornResultModal
      v-if="isWannasorn"
      v-model="showErrorModal"
      variant="danger"
      :title="errorModalTitle"
      :lines="errorModalLines"
      button-text="ตกลง"
      @confirm="showErrorModal = false"
    />
  </div>
</template>

<script>
import api from "../../../services/api.js";
import ChangePasswordForm from "./shared/ChangePasswordForm.vue";
import WannasornMemberCreateForm from "./shared/WannasornMemberCreateForm.vue";
import WannasornConfirmMemberModal from "./shared/WannasornConfirmMemberModal.vue";
import WannasornResultModal from "./shared/WannasornResultModal.vue";
import PageHeader from "./../../layouts/PageHeader";
import authMixin from "@/mixins/auth-mixin.js";
import { isWannasornCompany } from "@/helpers/wannasorn";

export default {
  components: {
    ChangePasswordForm,
    WannasornMemberCreateForm,
    WannasornConfirmMemberModal,
    WannasornResultModal,
    PageHeader
  },
  props: { company: { type: Object, default: null } },
  mixins: [authMixin],
  data() {
    return {
      comId: this.$store.state.Company.companyInfo.id,
      form: {
        firstName: "",
        lastName: "",
        email: null,
        phoneNumber: null,
        dateOfBirth: "",
        idCard: "",
        department: "",
        about: "",
        username: "",
        password: "",
        passwordConfirm: "",
        staffId: "",
        // Extended learner fields (Wannasorn)
        firstNameEn: "",
        lastNameEn: "",
        nickName: "",
        gender: "",
        gradeLevel: "",
        education: "",
        parentPhone: ""
      },
      submitted: false,
      showAlert: false,
      errors: [],
      errorMessage: "",
      isSetPassword: null,
      // Raw text in the password field (form.password is only set once confirmed).
      passwordInput: "",
      isSetConfirmPassword: null,
      // Wannasorn: preview-before-add + add-success/error modals
      showConfirmModal: false,
      showSuccessModal: false,
      showErrorModal: false,
      submitting: false,
      createdStudentId: "",
      errorModalTitle: "",
      errorModalLines: [],
    };
  },

  computed: {
    isWannasorn() {
      return isWannasornCompany(this.comId);
    },
    validation() {
      // this.errors = [];
      // const form = this.form;

      return {
        // firstName:
        //   this.form.firstName.length > 0 && this.form.firstName.length < 100,
        // lastName:
        //   this.form.lastName.length > 0 && this.form.lastName.length < 100,
        // email: this.validEmail(this.form.email),
        // phoneNumber: this.validPhoneNumber(this.form.phoneNumber),
        // idCard: this.validIdCard(this.form.idCard),
        // username: this.validUsername(this.form.username),
      };
    },
    thaiFullName() {
      return `${this.form.firstName} ${this.form.lastName}`.trim() || "-";
    }
  },

  methods: {
    addMember(form) {
      const payload = {
        company_id: this.company.id,
        first_name: form.firstName,
        last_name: form.lastName,
        email: form.email,
        phone_number: form.phoneNumber,
        id_card: form.idCard,
        department: form.department,
        about: form.about,
        staff_id: form.staffId,
        username: form.username,
        password: form.password
      };

      // Extended learner fields are only sent for Wannasorn companies. The Thai name inputs
      // double as the primary first/last name (mp_firstName + mp_firstNameTh).
      if (this.isWannasorn) {
        Object.assign(payload, {
          first_name_th: form.firstName,
          last_name_th: form.lastName,
          first_name_en: form.firstNameEn,
          last_name_en: form.lastNameEn,
          nick_name: form.nickName,
          gender: form.gender,
          date_of_birth: form.dateOfBirth,
          grade_level: form.gradeLevel,
          education: form.education,
          parent_phone: form.parentPhone
        });
      }

      api
        .post(`/v1/members`, payload)
        .then(({ data }) => {
          // Wannasorn: close the preview and show the auto-generated student id instead
          // of redirecting immediately.
          if (this.isWannasorn) {
            this.showConfirmModal = false;
            this.createdStudentId =
              data?.data?.studentId ?? data?.data?.student_id ?? "-";
            this.showSuccessModal = true;
            return;
          }

          this.$bvToast.toast("เพิ่มข้อมูลเรียบร้อยแล้ว.", {
            variant: "success",
            autoHideDelay: 3000,
            noCloseButton: true,
            solid: true
          });
          this.$router.push({ name: "member.index" });
        })
        .catch(({ response }) => {
          this.errorMessage = response.data.message;

          if (response.data.errors?.username?.[0]) {
            this.errors.push("username");
          }

          if (response.data.errors?.email?.[0]) {
            this.errors.push("email");
          }

          this.showConfirmModal = false;

          if (this.isWannasorn) {
            const { title, lines } = this.buildErrorModalContent(response);
            this.errorModalTitle = title;
            this.errorModalLines = lines;
            this.showErrorModal = true;
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    },

    buildErrorModalContent(response) {
      const title = "ไม่สามารถสร้างบัญชีผู้ใช้งานได้";
      const errors = response?.data?.errors || {};

      if (errors.email?.[0]) {
        return {
          title,
          lines: [
            `อีเมล ${this.form.email} นี้มีผู้ใช้งานแล้ว`,
            "กรุณาตรวจสอบอีเมลอีกครั้ง"
          ]
        };
      }

      if (errors.username?.[0]) {
        return {
          title,
          lines: [
            `ชื่อผู้ใช้งาน ${this.form.username} นี้มีผู้ใช้งานแล้ว`,
            "กรุณาตรวจสอบชื่อผู้ใช้งานอีกครั้ง"
          ]
        };
      }

      return {
        title,
        lines: [response?.data?.message || "กรุณาลองใหม่อีกครั้ง"]
      };
    },

    confirmAddMember() {
      this.submitting = true;
      this.addMember(this.form);
    },

    finishSuccess() {
      this.showSuccessModal = false;
      this.$router.push({ name: "member.index" });
    },

    async checkUsername(username) {
      this.removeError("username");
      if (username) {
        let { data } = await api.get(`/v1/check-username/${username}`);
        if (!data) {
          this.errors.push("username");
        }
      }
    },

    async checkEmail() {
      const email = this.form.email;
      this.removeError("email");
      if (!email) return;
      const taken = await this.isEmailTaken(email);
      // Ignore a stale response if the email changed while the request was in flight.
      if (taken && email === this.form.email) {
        this.errors.push("email");
      }
    },

    async isEmailTaken(email) {
      try {
        const { data } = await api.get(
          `/v1/email/${encodeURIComponent(email)}/company/${this.company.id}`
        );
        return data === true || data === "true";
      } catch (error) {
        // Don't block the form if the check itself fails; the backend still validates on create.
        console.error(error);
        return false;
      }
    },

    removeError(field) {
      const index = this.errors.indexOf(field);
      if (index !== -1) {
        this.errors.splice(index, 1);
      }
    },

    setPassword(data) {
      this.form.password = data.password;
      this.form.confirmPassword = data.passwordConfirm
      // Passwords now match: drop the error forced by an earlier failed submit.
      this.isSetConfirmPassword = null;
      this.removeError("confirmPassword");
    },

    clearPassword(passwordInput) {
      this.passwordInput = passwordInput || "";
      this.isSetPassword = null;
      this.form.password = "";
      this.form.confirmPassword = "";
    },

    async handleSubmit() {
      this.submitted = true;

      if (await this.validateForm()) {
        if (this.isWannasorn) {
          this.showConfirmModal = true;
        } else {
          this.addMember(this.form);
        }
      } else {
        console.log(this.errors);
      }
    },

    validateForm: async function() {
      this.errors = [];

      const form = this.form;

      if (!form.firstName) this.errors.push("firstName");
      if (!form.lastName) this.errors.push("lastName");
      // Wannasorn requires only firstName(TH), lastName(TH), phone and email.
      if (this.isWannasorn) {
        if (!form.phoneNumber) this.errors.push("phoneNumber");
        if (!form.email) this.errors.push("email");
      }
      if (!form.idCard && ( this.company.id == 485 || this.company.id == 513 || this.company.id == 519 ) ) this.errors.push("idCard");
      if (this.company.id == 513 || this.isWannasorn) {
        const thaiCharactersRegex = /^[ก-๙\s]+$/;
        if (!thaiCharactersRegex.test(this.form.firstName)){
          this.errors.push("firstName");
        }
        if (!thaiCharactersRegex.test(this.form.lastName)){
          this.errors.push("lastName");
        }
      }
      if (this.isWannasorn) {
        const englishRegex = /^[A-Za-z\s]+$/;
        if (form.firstNameEn && !englishRegex.test(form.firstNameEn)) {
          this.errors.push("firstNameEn");
        }
        if (form.lastNameEn && !englishRegex.test(form.lastNameEn)) {
          this.errors.push("lastNameEn");
        }
        if (!form.firstNameEn) this.errors.push("firstNameEn");
        if (!form.lastNameEn) this.errors.push("lastNameEn");
        if (!form.education) this.errors.push("education");
        if (!form.username) this.errors.push("username");
      }
      const isEmailFormatValid = !form.email || this.validEmail(form.email);
      const [usernameAvailable, emailTaken] = await Promise.all([
        form.username
          ? api.get(`/v1/check-username/${form.username}`).then(({ data }) => !!data)
          : true,
        this.isWannasorn && form.email && isEmailFormatValid
          ? this.isEmailTaken(form.email)
          : false,
      ]);
      if (!usernameAvailable) this.errors.push("username");
      if (!isEmailFormatValid || emailTaken) this.errors.push("email");
      if (form.phoneNumber && this.validPhoneNumber(form.phoneNumber))
        this.errors.push("phoneNumber");
      if (form.parentPhone && this.validPhoneNumber(form.parentPhone))
        this.errors.push("parentPhone");
      if (form.idCard && !this.validIdCard(form.idCard))
        this.errors.push("idCard");

      if (!this.validUsername(form.username)) this.errors.push("username");
      if (!this.form.confirmPassword) {
        // Password is required: flag the password field itself when nothing was typed.
        if (!this.passwordInput) this.isSetPassword = false;
        this.errors.push("confirmPassword");
        this.isSetConfirmPassword = false;
      }

      return !this.errors.length;
    },

    validEmail: function(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },

    onNumberKeyPress(event) {
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
      }
    },

    validPhoneNumber: function(phoneNumber) {
      const count = (phoneNumber.match(/\d/g) || []).length;
      return count < 9 || count > 15;
    },

    validIdCard: function(input) {
      return /^\d+$/.test(input) && input.length == 13;
    },

    validUsername: input =>
      input.length === 0 || /^[0-9a-zA-Z_.-]+/.test(input),

    validPassword: input => input.length >= 6,

    hasError(field) {
      const errors = this.errors;
      return errors.includes(field);
    }
  }
};
</script>
